/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toggleAuth } from "../Redux/Slices/auth-slice";
import { scrollToTop } from "../constent/helper";
import { Icon } from "../dashboard/admin/_adminApi";

function Header({ parent }) {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const { isLogin, userInfo } = useSelector((state) => state.authSlice || {});
  const hasAdminNav = userInfo?.user?.role === "admin" || userInfo?.user?.is_staff || userInfo?.user?.is_superuser;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const mobileNavRef = useRef(null);

  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };

  const handleLogout = () => {
    dispatch(toggleAuth({ isLogin: false, userInfo: null }));
    navigate("/");
    localStorage.removeItem("activeTab");
    setIsNavOpen(false);
  };

  const handleLinkClick = () => {
    scrollToTop();
    setIsNavOpen(false);
  };

  // Close mobile nav when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isNavOpen &&
        mobileNavRef.current &&
        !mobileNavRef.current.contains(event.target)
      ) {
        setIsNavOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isNavOpen]);

  // Prevent body scroll when mobile nav is open
  useEffect(() => {
    if (isNavOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isNavOpen]);



  const isActive = (to) => {
    if (!to) return false;
    if (to === "/") return location.pathname === "/";
    return location.pathname.startsWith(to);
  };

  const getLinkStyles = (to) => `site-nav-link${isActive(to) ? " active" : ""}`;

  const getMobileLinkStyles = (to) => {
    const activeClass = "text-primary-green hover:text-primary-green focus:text-primary-green";
    const inactiveClass = "text-black font-semibold hover:text-gray-700 transition-colors";
    return isActive(to) ? `${activeClass} font-semibold` : inactiveClass;
  };

  return (
    <>
      {/* Overlay for mobile */}
      <div
        className={`fixed inset-0 bg-black transition-opacity duration-300 lg:hidden z-[98] ${
          isNavOpen ? "opacity-50 visible" : "opacity-0 invisible"
        }`}
        onClick={() => setIsNavOpen(false)}
      ></div>

      <div className="site-nav">
        <div className="">
          <div className="flex justify-between items-center max-w-[1380px] mx-auto lg:px-8 md:px-6 px-4 w-full">
            {/* Logo and Hamburger */}
            <div className={`flex justify-between items-center z-[99] ${isLogin ? 'lg:w-max w-full':'w-full'}`}>
              <div className="py-[4px]">
                <Link to="/" onClick={handleLinkClick} className="site-brand">
                  <span className="site-brand-mark"><Icon.cross /></span>
                  <span>
                    <strong>KWF</strong>
                    <span className="t">Khadim Welfare Foundation</span>
                  </span>
                </Link>
              </div>
              <button
                className={`lg:hidden shadow-none flex flex-col gap-1.5 p-2 w-max cursor-pointer bg-transparent ${
                  "text-[#0E1B2C]"
                }`}
                onClick={toggleNav}
                aria-label="Toggle menu"
              >
                <div
                  className={`w-6 h-0.5 bg-current transition-all duration-300 ${
                    isNavOpen ? "rotate-45 translate-y-2" : ""
                  }`}
                ></div>
                <div
                  className={`w-6 h-0.5 bg-current transition-all duration-300 ${
                    isNavOpen ? "opacity-0" : ""
                  }`}
                ></div>
                <div
                  className={`w-6 h-0.5 bg-current transition-all duration-300 ${
                    isNavOpen ? "-rotate-45 -translate-y-2" : ""
                  }`}
                ></div>
              </button>
            </div>

            {/* Desktop Navigation */}
            <div className={`hidden lg:flex w-full items-center ml-8  ${isLogin ? 'justify-end':'justify-between'}`}>
              {!isLogin && (
                <div className="flex items-center gap-6">
                  <Link to="/" className={getLinkStyles("/")}>
                    Home
                  </Link>
                  <Link
                    to="/programs"
                    onClick={() => scrollToTop()}
                    className={getLinkStyles("/programs")}
                  >
                    Programs
                  </Link>
                  <Link
                    to="/aboutus"
                    onClick={() => scrollToTop()}
                    className={getLinkStyles("/aboutus")}
                  >
                    About us
                  </Link>
                  <Link
                    to="/casesfeeds"
                    onClick={() => scrollToTop()}
                    className={getLinkStyles("/casesfeeds")}
                  >
                    Projects
                  </Link>
                  <Link
                    to="/blogs"
                    onClick={() => scrollToTop()}
                    className={getLinkStyles("/blogs")}
                  >
                    Blogs
                  </Link>
                  {!isLogin && (
                    <Link
                      to="/login"
                      onClick={() => scrollToTop()}
                      className={getLinkStyles("/login")}
                    >
                      Login
                    </Link>
                  )}
                </div>
              )}
              <div className="flex items-center gap-6 justify-end">
                {isLogin ? (
                  hasAdminNav ? (
                    <>
                      <Link to="/dashboard" className={getLinkStyles("/dashboard")}>
                        Dashboard
                      </Link>
                      <Link to="/familylisting" className={getLinkStyles("/familylisting")}>
                        Family Listing
                      </Link>
                      <Link to="/memberlisting" className={getLinkStyles("/memberlisting")}>
                        Member Listing
                      </Link>
                      <Link
                        to="/propertydetailpage"
                        className={getLinkStyles("/propertydetailpage")}
                      >
                        Property Listing
                      </Link>
                      <a
                        onClick={handleLogout}
                        style={{ cursor: "pointer" }}
                        className={'primary-button'}
                      >
                        Logout
                      </a>
                    </>
                  ) : ["medicalstaff", "pharmacist"].includes(userInfo?.user?.role) ? (
                    <>
                      <Link
                        to="/dashboard/verify_fingerprint"
                        className={getLinkStyles("/dashboard/verify_fingerprint")}
                      >
                        Dashboard
                      </Link>
                      <a
                        onClick={handleLogout}
                        style={{ cursor: "pointer" }}
                        className={'primary-button'}
                      >
                        Logout
                      </a>
                    </>
                  ) : (
                    <>
                      <Link to="/familylisting" className={getLinkStyles("/familylisting")}>
                        Family Listing
                      </Link>
                      <Link to="/memberlisting" className={getLinkStyles("/memberlisting")}>
                        Member Listing
                      </Link>
                      <Link
                        to="/propertydetailpage"
                        className={getLinkStyles("/propertydetailpage")}
                      >
                        Property Listing
                      </Link>
                      <a
                        onClick={handleLogout}
                        style={{ cursor: "pointer" }}
                        className={'primary-button'}
                      >
                        Logout
                      </a>
                    </>
                  )
                ) : (
                  <Link
                    to="/donation"
                    onClick={() => scrollToTop()}
                    className="primary-button"
                  >
                    DONATE
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Navigation Sidebar */}
      <div
        ref={mobileNavRef}
        className={`fixed top-0 right-0 h-full w-[280px] bg-white shadow-2xl z-[200] lg:hidden transform transition-transform duration-300 ease-in-out ${
          isNavOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex flex-col h-full p-6 overflow-y-auto">
          <div className="flex flex-col gap-4 mt-16">
            {!isLogin && (
              <div className="flex flex-col gap-4">
                <Link
                  to="/"
                  onClick={handleLinkClick}
                  className={getMobileLinkStyles("/")}
                >
                  Home
                </Link>
                <Link
                  to="/programs"
                  onClick={handleLinkClick}
                  className={getMobileLinkStyles("/programs")}
                >
                  Programs
                </Link>
                <Link
                  to="/aboutus"
                  onClick={handleLinkClick}
                  className={getMobileLinkStyles("/aboutus")}
                >
                  About us
                </Link>
                <Link
                  to="/casesfeeds"
                  onClick={handleLinkClick}
                  className={getMobileLinkStyles("/casesfeeds")}
                >
                  Projects
                </Link>
                <Link
                  to="/blogs"
                  onClick={handleLinkClick}
                  className={getMobileLinkStyles("/blogs")}
                >
                Blogs
                </Link>
              </div>
            )}

            {isLogin ? (
              <>
                <div className=""></div>
                {hasAdminNav ? (
                  <>
                    <Link
                      to="/dashboard"
                      onClick={handleLinkClick}
                      className={getMobileLinkStyles("/dashboard")}
                    >
                      Dashboard
                    </Link>
                    <Link
                      to="/familylisting"
                      onClick={handleLinkClick}
                      className={getMobileLinkStyles("/familylisting")}
                    >
                      Family Listing
                    </Link>
                    <Link
                      to="/memberlisting"
                      onClick={handleLinkClick}
                      className={getMobileLinkStyles("/memberlisting")}
                    >
                      Member Listing
                    </Link>
                    <Link
                      to="/propertydetailpage"
                      onClick={handleLinkClick}
                      className={getMobileLinkStyles("/propertydetailpage")}
                    >
                      Property Listing
                    </Link>
                  </>
                ) : ["medicalstaff", "pharmacist"].includes(userInfo?.user?.role) ? (
                  <Link
                    to="/dashboard/verify_fingerprint"
                    onClick={handleLinkClick}
                    className={getMobileLinkStyles("/dashboard/verify_fingerprint")}
                  >
                    Dashboard
                  </Link>
                ) : (
                  <>
                    <Link
                      to="/familylisting"
                      onClick={handleLinkClick}
                      className={getMobileLinkStyles("/familylisting")}
                    >
                      Family Listing
                    </Link>
                    <Link
                      to="/memberlisting"
                      onClick={handleLinkClick}
                      className={getMobileLinkStyles("/memberlisting")}
                    >
                      Member Listing
                    </Link>
                    <Link
                      to="/propertydetailpage"
                      onClick={handleLinkClick}
                      className={getMobileLinkStyles("/propertydetailpage")}
                    >
                      Property Listing
                    </Link>
                  </>
                )}
                <span
                  onClick={handleLogout}
                  style={{ cursor: "pointer" }}
                  className="primary-button"
                >
                  Logout
                </span>
              </>
            ) : (
              <>
                <Link
                  to="/login"
                  onClick={handleLinkClick}
                  className={getMobileLinkStyles("/login")}
                >
                  Login
                </Link>
                <div className="mt-4">
                  <Link
                    to="/donation"
                    onClick={handleLinkClick}
                    className="primary-button inline-block text-center"
                  >
                    DONATE
                  </Link>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Header;
